<template>
  <div class="error_page">
    <div class="main">
      <div class="big">404</div>
      <div>你要访问的页面已经遗失在异次元空间中...</div>
      <div>{{ remainTime }}秒后返回主界面</div>
      <router-link to="/">点击此处立即返回</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      remainTime: 5,
    };
  },
  mounted() {
    const that = this;
    this.interval = setInterval(() => {
      that.remainTime -= 1;
      if (that.remainTime === 0) that.$router.push('/');
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.error_page {
  width: 100%;
  height: 100%;
  background-color: white;

  .main {
    width: 100%;
    position: absolute;
    top: 45%;
    transform: translateY(-50%);
    text-align: center;
    color:#0066FF;

    div {
      margin: 10px 0;
    }

    a {
      color: #076BF2;
    }

    .big {
      font-size: 100px;
      color: #076BF2;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/errorPage.vue